import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { adminLogin } from "../utils/api";
import { useAuth } from "../context/AuthContext";

export default function Login() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to="/" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const res = await adminLogin({ email, password });
      setUser(res.data);
      navigate("/");
    } catch (err) {
      setError(err.response?.data?.error || "Login failed. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: "100vh", display: "flex", alignItems: "center",
      justifyContent: "center", padding: 16, background: "#1a1f2e"
    }}>
      <div className="card" style={{ width: "100%", maxWidth: 400, padding: 36 }}>
        <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
          <img src="/logo.png" alt="TheHealthHire.com"
            style={{ height: 56, width: "auto", objectFit: "contain", maxWidth: 240 }} />
        </div>

        <div style={{
          display: "flex", alignItems: "center", justifyContent: "center",
          gap: 8, marginBottom: 24
        }}>
          <ShieldCheck size={16} style={{ color: "#1976e0" }} />
          <span style={{
            fontSize: 12, fontWeight: 700, color: "#718096",
            textTransform: "uppercase", letterSpacing: "0.1em"
          }}>
            Admin Panel
          </span>
        </div>

        {error && <div className="error-box" style={{ marginBottom: 16 }}>{error}</div>}

        <form onSubmit={handleSubmit}>
          <div style={{ marginBottom: 14 }}>
            <label style={{ fontSize: 12.5, fontWeight: 600, color: "#1a1f2e", display: "block", marginBottom: 6 }}>
              Email
            </label>
            <input
              className="input" type="email" required autoFocus
              placeholder="admin@thehealthhire.com"
              value={email} onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div style={{ marginBottom: 22 }}>
            <label style={{ fontSize: 12.5, fontWeight: 600, color: "#1a1f2e", display: "block", marginBottom: 6 }}>
              Password
            </label>
            <input
              className="input" type="password" required
              placeholder="••••••••"
              value={password} onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="btn btn-primary" type="submit" disabled={loading}
            style={{ width: "100%", padding: "12px" }}>
            {loading && <span className="spinner" />}
            {loading ? "Logging in..." : "Login to Admin Panel"}
          </button>
        </form>

        <p style={{ color: "#a0aec0", fontSize: 12, textAlign: "center", marginTop: 18, lineHeight: 1.6 }}>
          Restricted access. Admin accounts are created by a superadmin.
        </p>
      </div>
    </div>
  );
}
